__webpack_public_path__ = window.SpotlightVoucherCheck
